import { CurrencyRef, FinancePaymentStatus, Money } from '../../types/finance';

/** "USD 1,234.50" — the currency's code (symbols are ambiguous across
 * USD/LKR-style "$"/"Rs" setups), two decimals. */
export const formatMoney = (amount: number | null | undefined, currency?: CurrencyRef | null) =>
  amount == null
    ? '—'
    : `${currency?.code ?? ''} ${amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`.trim();

/** One line per currency, or "—" when there's nothing. */
export const formatMoneyList = (values: Money[]) =>
  values.length === 0 ? '—' : values.map((v) => formatMoney(v.amount, v.currency)).join(' · ');

export const formatDate = (value: string | null | undefined) =>
  value
    ? new Date(value).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    : '—';

export const PAYMENT_STATUS_LABEL: Record<FinancePaymentStatus, string> = {
  PAID: 'Paid',
  PARTIALLY_PAID: 'Partially paid',
  UNPAID: 'Unpaid',
  NO_FEES: 'No fees set',
};

export const PAYMENT_STATUS_COLOR: Record<
  FinancePaymentStatus,
  'success' | 'warning' | 'error' | 'default'
> = {
  PAID: 'success',
  PARTIALLY_PAID: 'warning',
  UNPAID: 'error',
  NO_FEES: 'default',
};
